import type { InstallAppProps } from '@wix/app-installer';

const urlParams = new URLSearchParams(window.location.search);

export const getPropsFromSearchParams = () => {
  const appId = urlParams.get('appId') || '';
  const tenantType = urlParams.get('metaSiteId')
    ? 'SITE'
    : (urlParams.get('tenantType') as InstallAppProps['tenantType']) || 'SITE';
  const tenantId =
    urlParams.get('tenantId') || urlParams.get('metaSiteId') || undefined;
  const version = urlParams.get('version') || undefined;
  const avoidPostInstallation =
    urlParams.get('avoidPostInstallation') === 'true';
  const versionOverrideId = urlParams.get('versionOverrideId') || undefined;
  const title = urlParams.get('title') || undefined;
  const subtitle = urlParams.get('subtitle') || undefined;
  const ctaText = urlParams.get('cta-text') || undefined;
  const openInIframe = urlParams.get('open-in-iframe') === 'true';
  const hideCloseButton = urlParams.get('hide-close-button') === 'true';

  return {
    appId,
    tenantType,
    tenantId,
    version,
    avoidPostInstallation,
    versionOverrideId,
    title,
    subtitle,
    ctaText,
    openInIframe,
    hideCloseButton,
  };
};
